<div [ngClass]="getUsageClass()" class="image">
  <div
    *ngIf="showBackgroundImage"
    [ngStyle]="{ 'background-image': 'url(' + getBackgroundImageUrl() + ')' }"
    class="blurred-background"
  ></div>
  <stxt-skeleton-loader *ngIf="shouldShowSkeleton()" [usage]="mediaUsage"></stxt-skeleton-loader>

  <img
    *ngIf="shouldShowImage()"
    [ngSrc]="src"
    [alt]="alt"
    [ngStyle]="{
      opacity: loadingState.isRendered ? 1 : 0,
      transition: 'opacity 1.5s ease'
    }"
    [ngClass]="{ blur: imageLocked }"
    [tabindex]="tabindex"
    [fill]="fill"
    [priority]="priority"
    (load)="onImageStateChange($event)"
    (error)="onImageStateChange($event)"
    stxtImageProtection
  />
</div>
